import { SelectionModel } from '@angular/cdk/collections';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { debounceTime } from 'rxjs/operators';
import { formConstant } from '../../../../../config';
import { onConfirmDialog } from '../../../../core/helpers/helpers.function';
import { PageParams } from '../../../../core/models/page-params.model';
import { IPaginatorProperties } from '../../../../core/models/paginator.interface';
import { LocalStorageService } from '../../../../core/services/local-storage.service';
import { NotificationService } from '../../../../core/services/notification.service';
import { UserService } from '../../../../core/services/user.service';
import { ConfirmPopupDialog } from '../../../../shared/popups/confirm-popup/confirm-popup.component';
import { IPriceXlsxFile } from '../../models/shipment-price.interface';
import { ShipmentPriceService } from '../../services/shipment-price.service';

@Component({
    selector: 'eci-upload-xlsx',
    templateUrl: './upload-xls.component.html',
    styleUrls: ['./upload-xls.component.scss']
})
export class UploadXlsComponent implements OnInit {

    public showLoader: boolean = false;
    public form: FormGroup;

    public listOfDocuments: IPriceXlsxFile[] = [];
    public dataSource: MatTableDataSource<IPriceXlsxFile> = new MatTableDataSource<IPriceXlsxFile>([]);
    public selection = new SelectionModel<IPriceXlsxFile>(true, []);

    public displayedColumns: string[] = [
        'select',
        'dateTime',
        'fileName',
        'vendor',
        'service',
        'subService',
        'carrierProvider',
        'templateUsed',
        'status',
        'action',
    ];

    public pageParams: PageParams = new PageParams();
    private currentSort: Sort = {active: 'createdAt', direction: 'desc'};

    @ViewChild('table', {static: true, read: ElementRef}) private table: ElementRef;

    constructor(
        public localStorageSvc: LocalStorageService,
        public userSvc: UserService,
        private shipmentPriceSvc: ShipmentPriceService,
        private notify: NotificationService,
        private dialog: MatDialog,
    ) {
    }

    ngOnInit() {
        this.form = this.initializeForm();
        this.searchSubscriber();
        this.getXlsxList();
    }

    private initializeForm(): FormGroup {
        this.pageParams.pageSize = formConstant.pageSize;
        this.pageParams.pageIndex = 0;
        return new FormGroup({
            search: new FormControl(''),
        });

    }

    private searchSubscriber(): void {
        this.form.get('search').valueChanges
            .pipe(debounceTime(500))
            .subscribe((value) => {
                this.getXlsxList();
            });
    }

    public getXlsxList(page: number = this.pageParams.pageIndex + 1 || 1,
                       limit: number = this.pageParams?.pageSize,
                       q: string = this.form?.get('search').value || '',
                       orderField: string = this.currentSort?.active || '',
                       orderDir: string = this.currentSort?.direction.toUpperCase() || ''): void {

        const filters = {};
        this.showLoader = true;

        this.shipmentPriceSvc.get<IPaginatorProperties<IPriceXlsxFile>>('shipment-price-document',
            page, limit, q, filters, orderField, orderDir)
            .subscribe((data) => {
                if (!data) {
                    return;
                }
                this.listOfDocuments = data.items;
                this.dataSource = new MatTableDataSource<IPriceXlsxFile>(this.listOfDocuments);
                this.pageParams.pageSize = data?.meta?.itemsPerPage;
                this.pageParams.pageIndex = data?.meta?.currentPage - 1;
                this.pageParams.length = data?.meta?.totalItems;
            }, (err) => {
                this.notify.showError(err.error.message);
            }, () => {
                this.showLoader = false;
            });
    }

    public pageChanged(e: PageParams): void {
        this.pageParams.pageIndex = e.pageIndex;
        this.pageParams.pageSize = e.pageSize;
        this.getXlsxList();
    }

    public sortData(sort: Sort): void {
        const data = this.listOfDocuments.slice();
        if (!sort.active || sort.direction === '') {
            this.dataSource = new MatTableDataSource<IPriceXlsxFile>(this.dataSource.data);
            return;
        }
        this.currentSort = sort;
        this.getXlsxList();
    }

    public downloadExcel(row: IPriceXlsxFile): void {
        this.shipmentPriceSvc.downloadPriceExcel(Number(row.id))
            .subscribe((res) => {
                const a = document.createElement('a');
                a.href = res.file;
                a.click();
            });
    }

    public delete(): void {
        this.showLoader = true;

        const ids = this.selection.selected.map((el) => el.id);
        this.shipmentPriceSvc.deleteList('shipment-price-document/delete', ids)
            .subscribe((res) => {
                if (!res) {
                    return;
                }
                this.dataSource.data = this.listOfDocuments.filter((item) => !ids.includes(item.id));
                this.selection.clear();
                this.pageParams.length -= ids.length;
                this.notify.showSuccessMessage('Deleted successfully');
            }, this.errorHandler, () => {
                this.showLoader = false;
            });
    }

    public get isAdmin(): boolean {
        return this.userSvc.isAdmin;
    }

    private errorHandler = (err) => {
        this.notify.showError(err.message);
    };

    public onDelete(): void {
        const onConfirm = () => {
            this.delete();
        };
        const dialogRef = this.dialog.open(ConfirmPopupDialog);
        onConfirmDialog(dialogRef, onConfirm, 'file(s)');
    }

}
